import { render, staticRenderFns } from "./userInfo_individualScore.vue?vue&type=template&id=47aa69fb&"
import script from "./userInfo_individualScore.vue?vue&type=script&lang=js&"
export * from "./userInfo_individualScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports